/* eslint-disable react/require-default-props */
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Badge } from "@xfrontend/xui-react-plus";

type StatusTagProps = {
  enabled: boolean;
  className?: string;
};

const StyledTag = styled(Badge)<{ $color: string; $bg: string }>`
  display: inline-block;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 14px;
  line-height: 1;
  color: ${(props) => props.$color};
  background-color: ${(props) => props.$bg};
`;

const StatusTag = ({ enabled, className }: StatusTagProps): JSX.Element => {
  const { t } = useTranslation("applications");
  return (
    <StyledTag
      bg=""
      $color="var(--x-gray-200, #f6f6f7)"
      $bg={enabled ? "var(--x-theme-success, #00AAB6)" : "var(--x-theme-secondary, #73698a)"}
      className={className}
    >
      {enabled ? t("status.enabled") : t("status.disabled")}
    </StyledTag>
  );
};

export default StatusTag;
